/* eslint-disable max-classes-per-file */

import { ICartItem } from '../models/cart-item.model';

export class LoadCart {
  static readonly type = '[Storage Cart] Load Cart';
}

export class AddToCart {
  static readonly type = '[Storage Cart] Add To Cart';
  constructor(public item: ICartItem) {}
}

export class AddManyToCart {
  static readonly type = '[Storage Cart] Add Many To Cart';
  constructor(public items: ICartItem[]) {}
}

export class RemoveFromCart {
  static readonly type = '[Storage Cart] Remove From Cart';
  constructor(public productId: string) {}
}

export class UpdateCartItemQuantity {
  static readonly type = '[Storage Cart] Update Cart Item Quantity';
  constructor(
    public productId: string,
    public quantity: number
  ) {}
}

export class ClearCart {
  static readonly type = '[Storage Cart] Clear Cart';
}
